import { atom } from "recoil";

export const DataNationState = atom({
  key: "DataNationState",
  default: [],
});
